import { render, staticRenderFns } from "./DocumentClassification.vue?vue&type=template&id=156e6eef"
import script from "./DocumentClassification.vue?vue&type=script&lang=js"
export * from "./DocumentClassification.vue?vue&type=script&lang=js"
import style0 from "./DocumentClassification.vue?vue&type=style&index=0&id=156e6eef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports